import {ChessPieces, fenToPiece} from "./chessPieces";

export const calculateTakenPiecesFromFen = (fen, color) => {
    const piecePlacements = fen.split(" ")[0]
    let pieceRegex;
    if(color === "white") {
        pieceRegex = /([A-Z])/g
    } else {
        pieceRegex = /([a-z])/g
    }

    const pieceCounts = new Map()

    pieceCounts.set(ChessPieces.KING, 1);
    pieceCounts.set(ChessPieces.QUEEN, 1);
    pieceCounts.set(ChessPieces.ROOK, 2);
    pieceCounts.set(ChessPieces.BISHOP, 2);
    pieceCounts.set(ChessPieces.KNIGHT, 2);
    pieceCounts.set(ChessPieces.PAWN, 8);


    let match;
    while ((match = pieceRegex.exec(piecePlacements)) !== null) {
        pieceCounts.set(fenToPiece[match[1].toLowerCase()], pieceCounts.get(fenToPiece[match[1].toLowerCase()]) - 1);
    }

    return pieceCounts;
}

const fenColorRegex = /.*? ([wb])/
export const getCurrentTurnFromFen = (fen) => {
    const match = fen.match(fenColorRegex);

    if (!match) {
        throw new Error("Invalid fen provided")
    }

    return match[1];
}